import { render, staticRenderFns } from "./GeneralTemplateConfigurationModal.vue?vue&type=template&id=462f915b&"
import script from "./GeneralTemplateConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./GeneralTemplateConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462f915b')) {
      api.createRecord('462f915b', component.options)
    } else {
      api.reload('462f915b', component.options)
    }
    module.hot.accept("./GeneralTemplateConfigurationModal.vue?vue&type=template&id=462f915b&", function () {
      api.rerender('462f915b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notifications/GeneralTemplateConfigurationModal.vue"
export default component.exports